/**
 * 이메일 검증 정규식
 *
 * 이메일 형식:
 * - 로컬 부분: 영어, 숫자, 점(.), 하이픈(-), 언더스코어(_), 플러스(+)
 * - @ 기호
 * - 도메인 부분: 영어, 숫자, 하이픈(-), 점(.)
 * - TLD: 영어 2글자 이상 (.com, .co.kr, .org 등)
 */
export const EMAIL_REGEX = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

/**
 * 비밀번호 검증 정규식
 *
 * 비밀번호 조건:
 * - 영어 대소문자 (a-z, A-Z)
 * - 숫자 (0-9)
 * - 특수문자 (!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?)
 * - 최소 6자, 최대 16자
 */
export const PASSWORD_REGEX = /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{6,16}$/

/**
 * 전화번호 검증 정규식
 *
 * 전화번호 형식: 01012345678 (하이픈 없이 11자리)
 */
export const PHONE_REGEX = /^01[016789][0-9]{4}[0-9]{4}$/

/**
 * 이메일 유효성 검증 함수
 * @param email - 검증할 이메일 주소
 * @returns - 유효한 이메일이면 true, 아니면 false
 */
export const validateEmail = (email: string): boolean => {
  return EMAIL_REGEX.test(email)
}

/**
 * 비밀번호 유효성 검증 함수
 * @param password - 검증할 비밀번호
 * @returns - 유효한 비밀번호면 true, 아니면 false
 */
export const validatePassword = (password: string): boolean => {
  return PASSWORD_REGEX.test(password)
}


/**
 * 전화번호 유효성 검증 함수
 * @param phone - 검증할 전화번호
 * @returns - 유효한 전화번호면 true, 아니면 false
 */
export const validatePhone = (phone: string): boolean => {
  return PHONE_REGEX.test(phone)
}